import { pipe } from 'fp-ts/function';
import { createAuthorizedGetRequest, decode, fetchApi } from '@/services/api';
import { chain } from 'fp-ts/TaskEither';
import { countryListCodec } from '@/services/api/resources/country/codec';

const baseUrl = '/v2/countries';

export const list = () => pipe(
  baseUrl,
  createAuthorizedGetRequest,
  chain(fetchApi),
  chain(decode(countryListCodec)),
);
